import React from 'react';
import { Users, TrendingUp, Award, Activity } from 'lucide-react';

export function ClubDashboardPage() {
  const clubStats = [
    { label: 'Total Teams', value: '1', icon: Users, color: 'blue' },
    { label: 'Total Players', value: '12', icon: Activity, color: 'green' },
    { label: 'Assessments', value: '2', icon: Award, color: 'purple' },
    { label: 'Avg Progress', value: '+6.2%', icon: TrendingUp, color: 'orange' },
  ];

  return (
    <div className="p-4 lg:p-8 max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-1">
          Club Dashboard
        </h1>
        <p className="text-gray-600">Overview of all teams and player development</p>
      </div>

      {/* Club Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {clubStats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.label} className="bg-white rounded-xl border border-gray-200 p-6">
              <div className={`w-12 h-12 bg-${stat.color}-100 rounded-lg flex items-center justify-center mb-3`}>
                <Icon className={`w-6 h-6 text-${stat.color}-600`} />
              </div>
              <p className="text-2xl font-bold text-gray-900 mb-1">{stat.value}</p>
              <p className="text-sm text-gray-600">{stat.label}</p>
            </div>
          );
        })}
      </div>

      {/* Coming Soon */}
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Users className="w-8 h-8 text-gray-400" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Club Analytics Coming Soon
        </h2>
        <p className="text-gray-600 max-w-md mx-auto">
          View comprehensive club-wide analytics, compare teams, and track development trends across your organization.
        </p>
      </div>
    </div>
  );
}
